<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form>
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="id"
                  style="width: 90px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="id">
                    Trans ID
                  </a-select-option>
                  <!-- <a-select-option value="site">
                    Site
                  </a-select-option> -->
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <!-- <a-radio-group
                v-model="table.filters.status_code"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio :style="radio.style" value="I">
                  In-Transit
                </a-radio>
                <a-radio :style="radio.style" value="R">
                  Received
                </a-radio>
              </a-radio-group> -->

              <a-select
                v-model="table.filters.status_code"
                @change="setFilter"
                show-search
                optionFilterProp="children"
              >
                <a-select-option :value="null">All</a-select-option>
                <a-select-option value="R">Received</a-select-option>
                <a-select-option value="I">In-Transit</a-select-option>
              </a-select>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
        >
          <!-- <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Card Order</base-button
            >
          </template> -->

          <template #formDrawer>
            <a-drawer
              :key="keyCheck"
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <TransferInForm
                :viewMode="viewMode"
                :transferInData="transferInData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <button
              id="view"
              v-if="
                selectedActions.includes('Receive') &&
                  tableProps.rowData.transferStatus.name != 'Received'
              "
              class="btn btn-warning btn-sm w-100" style="background-color: rgb(255, 157, 92) !important;"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Receive
            </button>
            <button
              id="view"
              v-if="tableProps.rowData.transferStatus.name == 'Received'"
              class="btn btn-success btn-sm w-100"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import TransferInForm from './TransferInForm.vue';
import secureStorage from '../../controllers/secureStorage';
import { mapGetters } from 'vuex';
import moment from 'moment';
import HTTPRequest from '../../controllers/httpRequest';


export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    TransferInForm
  },
  data() {
    return {
      // selectedActions: [],
      keyCheck: 1,
      gradientType: 'gradient-teal',
      search: null,
      searchType: 'id',
      transferInData: null,
      drawer: {
        visible: false,
        width: 1100,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Transfer In',
        apiUrl:
          '/api/v1/cards/transfer_in?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [
          'actions',
          { name: 'id', title: 'Transfer ID' },
          { name: 'transferOriginSiteName.name', title: 'Origin Site' },
          { name: 'transferStatus.name', title: 'Transfer Status' },
          {
            name: 'cards',
            title: 'Quantity',
            formatter(value) {
              return value.length;
            }
          },
          { name: 'createdBy.name', title: 'Created By' },
          {
            name: 'created_at',
            title: 'Date Created',
            formatter(value) {
              return moment(value).format('LLL');
            }
          }
        ],
        filters: {
          status_code: null,
          name: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    async openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.transferInData = rowData;
      // Call and endpoint for card details and summary
      const response = await HTTPRequest.getRequest(
        '/api/v1/cards/transfer_in/' + this.transferInData.id + '/card_details' 
      );
      this.transferInData.fullCardDetails = response;
      this.keyCheck++;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.transferInData = null;
    },

    searchTypeOnChange() {
      this.table.filters.id = null;
      this.table.filters.site = null;
      this.table.filters[this.searchType] = this.search;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    }
  },

  watch: {
    search(val) {
      if (val == '') this.search = null;
      this.table.filters[this.searchType] = val;
      this.setFilter();
    }
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'CardTransferIn');
  },

  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
